import React from 'react'
import { NavLink } from "react-router-dom";
import '../css/Navbar.min.css'
export default function Navbar() {
    return (
        <header>
            <nav className="navbar">
                <ul>
                    <li>
                        <NavLink exact activeClassName="nav_active" to="/"><span className="show">Home</span><span className="icon"><i class="fa fa-home" aria-hidden="true"></i></span></NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="nav_active" to="/about"><span className="show">About</span><span className="icon"><i class="fa fa-user" aria-hidden="true"></i></span></NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="nav_active" to="/portfolio"><span className="show">Portfolio</span><span className="icon"><i class="fa fa-briefcase" aria-hidden="true"></i></span></NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="nav_active" to="/contact"><span className="show">Contact</span><span className="icon"><i class="fa fa-envelope-open-o" aria-hidden="true"></i></span></NavLink>
                    </li>
                </ul>
            </nav>
        </header>
    )
}
